import React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { useCustomStyleMap } from "../../../utils/styles";

const TabPanel = props => {
  const { customSx, children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 3, ...customSx?.Box }}>{children}</Box>
    </Typography>
  );
};

TabPanel.defaultProps = {
  children: null,
  customSx: {},
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  customSx: PropTypes.object,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const ScrollableTabs = ({ customStyle, tabs }) => {
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }
  const customSx = useCustomStyleMap(customStyle);
  return (
    <Box
      sx={theme => ({
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
      })}
    >
      <AppBar sx={customSx.appBar} position="static" color="default">
        <Tabs
          style={{ borderBottom: "1px solid #e8e8e8" }}
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {tabs.map((tab, idx) => {
            // eslint-disable-next-line react/no-array-index-key
            return <Tab key={`${tab.title}_tab_${idx}`} label={tab.title} {...a11yProps(idx)} />;
          })}
        </Tabs>

        {tabs.map((tab, idx) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <TabPanel key={`${tab.title}_panel_${idx}`} customSx={customSx} value={value} index={idx}>
              {tab.component}
            </TabPanel>
          );
        })}
      </AppBar>
    </Box>
  );
};

ScrollableTabs.defaultProps = {
  customStyle: null,
};

ScrollableTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  customStyle: PropTypes.func,
};

export default ScrollableTabs;
